module.exports = {
    'All': 'Toutes'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/amateur_films.js